import React, { useState } from "react";
import { MoreLikeThisGrid } from "web/react/components/more-like-this-grid/more-like-this-grid";
import { UrlOverlay } from "web/react/components/url-overlay";
import { useRothkoFetcher } from "web/react/hooks/use-rothko-fetcher";
import { useUrlData } from "web/react/hooks/use-url-data/use-url-data";
import { gettext } from "web/script/modules/django-i18n";
import { RelatedProductsAreaSerializer } from "web/types/serializers";
import * as styles from "./related-products-overlay.css";
import { getOverlayDecision, getProductSlugFromPath } from "./utils";

interface RelatedProductsOverlayProps {
    parentRef?: React.RefObject<HTMLElement>;
}

export function RelatedProductsOverlay({
    parentRef,
}: RelatedProductsOverlayProps): React.ReactElement | null {
    const [relatedProductsData, setRelatedProductsData] =
        useState<RelatedProductsAreaSerializer | null>(null);
    const [fetch, isLoading] = useRothkoFetcher<RelatedProductsAreaSerializer>(
        "modules/product/related_products_area"
    );
    const urlData = useUrlData();

    async function load(controller: AbortController): Promise<void> {
        if (!urlData) {
            return;
        }

        const { newURL: url } = urlData;
        const productSlug = getProductSlugFromPath(url);
        const linkId = url.searchParams.get("link_id");

        return fetch(
            {
                slug: productSlug,
                link_id: linkId,
            },
            controller.signal
        ).then((data) => {
            setRelatedProductsData(data);
            // handlePageAnalytics(data);
        });
    }

    return (
        <UrlOverlay
            parentRef={parentRef}
            load={load}
            isLoading={isLoading}
            getOverlayDecision={getOverlayDecision}
        >
            {relatedProductsData && (
                <div className={styles.container}>
                    <MoreLikeThisGrid
                        title={gettext("product.buy_area.more_like_this.label")}
                        section={relatedProductsData.sections[0]}
                        isInStock
                    />
                </div>
            )}
        </UrlOverlay>
    );
}
